<template>
  <section class="shield-home s-home">
    <ShieldHeader />

    <div class="container-wide">
      <div class="content">
        <ShieldNavigation />

        <ShieldCarousel />

        <div class="copy">
          &nbsp;
        </div>
      </div>
    </div>

    <ShieldFooter />
  </section>
</template>

<script>
import ShieldHeader from "@/components/ShieldHeader.vue";
import ShieldNavigation from "@/components/ShieldNavigation.vue";
import ShieldCarousel from "@/components/ShieldCarousel.vue";
import ShieldFooter from "@/components/ShieldFooter.vue";

export default {
  name: "ShieldHome",
  components: {
    ShieldHeader,
    ShieldNavigation,
    ShieldCarousel,
    ShieldFooter
  }
};
</script>

<style lang="scss" scoped>
.content {
  background: #fff;
  min-height: 50vh;
}

.section-link {
  text-decoration: none;
}

.section-link:link,
.section-link:visited {
  color: #444;
}
</style>
